import api from "./api";

export const adminService = {
  // Get all agents deliveries
  getAllDeliveries: async (params = {}) => {
    const response = await api.get("/admin/deliveries-enhanced", { params });
    return response.data.data;
  },
  // Update delivery status (admin only)
  updateDeliveryStatus: async (delivery_id, status) => {
    const response = await api.patch(`/admin/deliveries/${delivery_id}/status`, { pickupStatus: status });
    return response.data.data;
  },
  // Update payment status (admin only)
  updatePaymentStatus: async (delivery_id, status) => {
    const response = await api.patch(`/admin/deliveries/${delivery_id}/payment`, { paymentStatus: status });
    return response.data.data;
  },
  // Get all sales (admin only)
  getAllSales: async (params = {}) => {
    const response = await api.get("/admin/sales-enhanced", { params });
    return response.data.data;
  },
  // Update sale status (admin only)
  updateSaleStatus: async (sale_id, status) => {
    const response = await api.patch(`/admin/sales/${sale_id}/status`, { status });
    return response.data.data;
  },
  // Get pending validations (admin only)
  getPendingValidations: async (params = {}) => {
    const response = await api.get("/admin/pending-validations", { params });
    return response.data.data;
  },
  getAllAgents: async () => {
    const response = await api.get("/admin/agents");
    return response.data.data.agents || [];
  },
  reassignPendingValidations: async ({ binIds, agentId }) => {
    const response = await api.post("/admin/pending-validations/reassign", { binIds, agentId });
    return response.data;
  },
  // Get validation history (admin only)
  getValidationHistory: async (params = {}) => {
    const response = await api.get("/admin/validation-history", { params });
    return response.data.data;
  },
  // Set agent fee per kg (admin only)
  setAgentFee: async (feePerKg) => {
    const response = await api.post("/admin/agent-fee", { feePerKg });
    return response.data.data;
  },
  // Get current agent fee (admin only)
  getAgentFee: async () => {
    const response = await api.get("/admin/agent-fee");
    return response.data.data.feePerKg;
  },
  // Move bin to delivery history (admin only)
  moveToDeliveryHistory: async (binId) => {
    const response = await api.post(`/admin/validation-history/${binId}/move-to-delivery`);
    return response.data.data;
  },
  // Get all deliveries for admin (new method)
  getAllDeliveriesAdmin: async (params = {}) => {
    const response = await api.get("/admin/deliveries", { params });
    return response.data.data;
  },

  // App slideshow management (admin)
  getAppSlideshow: async () => {
    const response = await api.get("/admin/slideshow");
    return response.data.data.slides || [];
  },

  updateAppSlideshow: async ({ slides }) => {
    const response = await api.put("/admin/slideshow", { slides });
    return response.data.data.slides || [];
  },

  listUsersAdmin: async (params = {}) => {
    const response = await api.get("/admin/users-v2", { params });
    return response.data.data;
  },

  updateUserAdmin: async (userId, payload) => {
    const response = await api.patch(`/admin/users/${userId}`, payload);
    return response.data.data.user;
  },

  listPendingAgentRequests: async (params = {}) => {
    const response = await api.get("/admin/agents/pending", { params });
    return response.data.data;
  },

  listApprovedAgentsAdmin: async (params = {}) => {
    const response = await api.get("/admin/agents/approved", { params });
    return response.data.data;
  },

  approveAgentRequest: async (userId) => {
    const response = await api.post(`/admin/agents/${userId}/approve`);
    return response.data;
  },

  rejectAgentRequest: async (userId) => {
    const response = await api.post(`/admin/agents/${userId}/reject`);
    return response.data;
  },

  updateAgentDetailsAdmin: async (userId, payload) => {
    const response = await api.patch(`/admin/agents/${userId}/details`, payload);
    return response.data.data.user;
  },
};
